import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../api/api-response';
import { RegraEmpresa, SalvarRegraEmpresaPayload } from './regra-empresa.model';

@Injectable({ providedIn: 'root' })
export class RegraEmpresaService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/Cupom`;

  listar(nrSeqCupom: number): Observable<ApiResponse<RegraEmpresa[]>> {
    return this.http.get<ApiResponse<RegraEmpresa[]>>(`${this.url}/${nrSeqCupom}/regra-empresa`);
  }

  criar(nrSeqCupom: number, payload: SalvarRegraEmpresaPayload): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.url}/${nrSeqCupom}/regra-empresa`, payload);
  }

  excluir(nrSequencia: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.url}/regra-empresa/${nrSequencia}`);
  }
}
